import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid } from "recharts";
import { Hash } from "lucide-react";

export const chartCommon = { style: { fontFamily: "JetBrains Mono", fontSize: 10, fill: "#62677A" } };
const TOOLTIP_STYLE = { background: "#111218", border: "1px solid rgba(244,240,230,0.1)", fontFamily: "JetBrains Mono", fontSize: 12, color: "#F4F0E6" };

export function Card({ title, icon: Icon, children, testid }) {
  return (
    <div data-testid={testid} className="bg-surface border border-white/5 rounded-xl p-5 sm:p-6 relative">
      <div className="flex items-center gap-2 label-caps mb-4">
        {Icon && <Icon className="w-3 h-3 text-oracle" strokeWidth={1.5} />} {title}
      </div>
      {children}
    </div>
  );
}

function FrequencyBars({ data, interval, color, cursor, cells = false }) {
  return (
    <div className="w-full h-64">
      <ResponsiveContainer>
        <BarChart data={data || []} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <CartesianGrid stroke="rgba(244,240,230,0.05)" vertical={false} />
          <XAxis dataKey="name" interval={interval} {...chartCommon} tickLine={false} axisLine={{ stroke: "rgba(244,240,230,0.1)" }} />
          <YAxis {...chartCommon} tickLine={false} axisLine={false} />
          <Tooltip contentStyle={TOOLTIP_STYLE} cursor={{ fill: cursor }} />
          <Bar dataKey="count" fill={color} radius={[2, 2, 0, 0]}>
            {cells && (data || []).map((d) => <Cell key={d.name} fill={color} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function FrequencyCharts({ freq }) {
  const whites = freq?.whites?.map((r) => ({ name: r.num, count: r.count }));
  const powerballs = freq?.powerball?.map((r) => ({ name: r.num, count: r.count }));
  return (
    <>
      <div className="lg:col-span-8">
        <Card title="White Ball Frequency (1–69, All-Time)" icon={Hash} testid="chart-whites">
          <FrequencyBars data={whites} interval={4} color="#2E5BFF" cursor="rgba(255,176,0,0.06)" cells />
        </Card>
      </div>
      <div className="lg:col-span-4">
        <Card title="Powerball Frequency (1–26)" icon={Hash} testid="chart-pb">
          <FrequencyBars data={powerballs} interval={1} color="#E50914" cursor="rgba(229,9,20,0.08)" />
        </Card>
      </div>
    </>
  );
}
